import Glass from "./Glass";


export default function SidePanel({config, dimensions}) {
  return (
    <div
        className="sidePanel"
        style={{
            backgroundColor: config?.color?.color,
        }}
    >
      <Glass config={config} dimensions={dimensions}/>
    </div>
  )
}
